import { createSelector } from '@reduxjs/toolkit';

import {
  getIsDescriptionModified,
  getIsLabelModified,
} from 'src/containers/ProjectDiagram/utils/draft/draftModelConcept';
import {
  getAddedRelationshipSourcesAndTargets,
  hasPreviousRelationship,
} from 'src/containers/ProjectDiagram/utils/draft/draftRelationship';
import { diagramSnapshotSelector } from 'src/selectors/diagramSnapshot';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';

export const relationshipDraftChangesSelector = memoizeSelectorFactory(
  (projectId: string, iri: string | undefined) =>
    createSelector(diagramSnapshotSelector(projectId), (diagram) => {
      if (!diagram?.model?.modelData?.draftData || !iri) {
        return {
          isDescriptionModified: false,
          isLabelModified: false,
          addedSources: new Set<string>(),
          addedTargets: new Set<string>(),
        };
      }

      const isNewRelationship = !hasPreviousRelationship(diagram, iri);

      const isDescriptionModified = getIsDescriptionModified({
        iri,
        isNewConcept: isNewRelationship,
        diagram,
      });

      const isLabelModified = getIsLabelModified({
        iri,
        isNewConcept: isNewRelationship,
        diagram,
      });

      const { addedSources, addedTargets } =
        getAddedRelationshipSourcesAndTargets({
          isNewRelationship,
          relationshipIri: iri,
          diagram,
        });

      return {
        isDescriptionModified,
        isLabelModified,
        addedSources,
        addedTargets,
      };
    })
);
